module.exports = __webpack_public_path__ + "static/img/deng1.a58f5e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhongqiu/deng1.png
// module id = gsZV
// module chunks = 1